export enum SectionIds {
  OVERVIEW = 'overview-section',
  PRODUCT_DETAILS = 'product-details-section',
  INGREDIENTS = 'ingredients-section',
  PROMISES = 'promises',
  HOW_TO_USE = 'how-to-use-section',
  FAQS = 'faq-section',
}
